import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Referral Interest', path: '/placement' },
    { name: 'Our Homes', path: '/homes' },
    { name: 'The Chasnell Home™', path: '/chasnell' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-cream-100/90 backdrop-blur-xl border-b border-sage-200" data-testid="site-header">
      <nav className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10" aria-label="Primary">
        <div className="flex items-center justify-between h-24 lg:h-28">
          <Link
            to="/"
            className="flex items-center hover:opacity-80 transition-opacity duration-300 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest-800 focus-visible:ring-offset-2 focus-visible:ring-offset-cream-100 lg:pr-8"
            data-testid="logo-home-link"
            onClick={() => setOpen(false)}
          >
            <img
              src="/logo.png"
              alt="Forever Path Living — home"
              className="h-[4.6rem] sm:h-20 lg:h-20 w-auto object-contain"
              style={{ filter: 'brightness(0.9) contrast(1.08)' }}
            />
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.path === '/' ? 'home' : link.path.slice(1)}`}
                className={`px-3.5 py-2 rounded-full text-sm font-medium transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest-800 focus-visible:ring-offset-2 focus-visible:ring-offset-cream-100 ${
                  isActive(link.path)
                    ? 'bg-forest-800 text-cream-100'
                    : 'text-forest-700 hover:text-gold-700 hover:bg-sage-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <button
            className="lg:hidden p-2 rounded-lg text-forest-800 hover:bg-sage-100 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest-800"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-4" data-testid="mobile-menu">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-xl text-base font-medium transition-colors ${
                    isActive(link.path)
                      ? 'bg-forest-800 text-cream-100'
                      : 'text-forest-800 hover:bg-sage-100'
                  }`}
                  onClick={() => setOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
